import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "sonner";
import AuthPage from "./pages/AuthPage";
import StreamPage from "./pages/StreamPage";
import SettingsPage from "./pages/SettingsPage";
import UnlockPage from "./pages/UnlockPage";
import { getMasterKey } from "./lib/crypto";
import { initML } from "./lib/ml";

initML();

function Gate({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center text-muted-foreground">
        <span className="meta-label">opening your stream…</span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  if (!getMasterKey()) return <Navigate to="/unlock" replace />;
  return children;
}

function PublicGate({ children }) {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/auth"
              element={
                <PublicGate>
                  <AuthPage />
                </PublicGate>
              }
            />
            <Route
              path="/"
              element={
                <Gate>
                  <StreamPage />
                </Gate>
              }
            />
            <Route
              path="/settings"
              element={
                <Gate>
                  <SettingsPage />
                </Gate>
              }
            />
            <Route path="/unlock" element={<UnlockPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "hsl(var(--card))",
              color: "hsl(var(--foreground))",
              border: "1px solid hsl(var(--border))",
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </ThemeProvider>
  );
}
